$(function () {
    getFeatureVideo();
});

function getFeatureVideo() {
    const formId = $('#frmPaintThehouse');
    var postUrl = formId.attr('action');
    const dataSourceId= formId.find('input[name="MBoxName"]').val();
    $.ajax({
        url: postUrl,
        type: 'POST',
        data: { "dataSourceId": dataSourceId, SiteName: $('#hdnSiteName').val() || null },
        success: function (data) {
            $(".skeleton--feature-banner_skeletonLoader").remove();
            if (data) {
                $('#paint-the-house').html(data);
            }
        },
        error: function (jqXhr) {
            $(".skeleton--feature-banner_skeletonLoader").remove();
            subwayScript.showAjaxError(jqXhr);
        }
    });
}